import ENGLISH_LABELS_STRING from './translations/english-labels-string.txt';
import ESTONIAN_LABELS_STRING from './translations/estonian-labels-string.txt';
import FINNISH_LABELS_STRING from './translations/finnish-labels-string.txt';
import LATVIAN_LABELS_STRING from './translations/latvian-labels-string.txt';
import LITHUANIAN_LABELS_STRING from './translations/lithuanian-labels-string.txt';
import RUSSIAN_LABELS_STRING from './translations/russian-labels-string.txt';
import SWEDISH_LABELS_STRING from './translations/swedish-labels-string.txt';
import POLISH_LABELS_STRING from './translations/polish-labels-string.txt';
import JAPANESE_LABELS_STRING from './translations/japanese-labels-string.txt';
import VIETNAMESE_LABELS_STRING from './translations/vietnamese-labels-string.txt';
import {UserStore} from '../user/user-store';

export class LabelStore {

    private labelsByKey: Map<string, Label>;

    constructor(private userStore: UserStore) {
        this.labelsByKey = new Map<string, Label>();

        const englishLabels: Map<string, string> = this.mapLabels(ENGLISH_LABELS_STRING);
        const estonianLabels = this.mapLabels(ESTONIAN_LABELS_STRING);
        const finnishLabels = this.mapLabels(FINNISH_LABELS_STRING);
        const latvianLabels = this.mapLabels(LATVIAN_LABELS_STRING);
        const lithuanianLabels = this.mapLabels(LITHUANIAN_LABELS_STRING);
        const russianLabels = this.mapLabels(RUSSIAN_LABELS_STRING);
        const swedishLabels = this.mapLabels(SWEDISH_LABELS_STRING);
        const polishLabels = this.mapLabels(POLISH_LABELS_STRING);
        const vietnameseLabels = this.mapLabels(VIETNAMESE_LABELS_STRING);
        const japaneseLabels = this.mapLabels(JAPANESE_LABELS_STRING);

        englishLabels.forEach((value, key) => {
            const englishText = value;
            const estonianText = estonianLabels.get(key);
            const finnishText = finnishLabels.get(key);
            const latvianText = latvianLabels.get(key);
            const lithuanianText = lithuanianLabels.get(key);
            const russianText = russianLabels.get(key);
            const swedishText = swedishLabels.get(key);
            const polishText = polishLabels.get(key);
            const vietnameseText = vietnameseLabels.get(key);
            const japaneseText = japaneseLabels.get(key);

            this.labelsByKey.set(key, {
                en: englishText,
                et: estonianText || englishText,
                fi: finnishText || englishText,
                lt: lithuanianText || englishText,
                lv: latvianText || englishText,
                ru: russianText || englishText,
                sv: swedishText || englishText,
                pl: polishText || englishText,
                vi: vietnameseText || englishText,
                ja: japaneseText || englishText,
            });
        });
    }

    mapLabels(labelsString: string): Map<string, string> {
        const map = new Map<string, string>();

        labelsString.trim()
            .split(/\n\n+/)
            .map((labelString) => labelString.split('\n'))
            .forEach((labelParts) => {
                const key = labelParts[0];
                const text = labelParts[1];

                map.set(key, text);
            });

        return map;
    }

    hasLabel(key: string): boolean {
        return this.labelsByKey.has(key);
    }

    label(key: string, parameters: LabelParameters = {}): string {
        return this.translate(key, this.language, parameters);
    }

    get language(): Language {
        if (this.userStore.state === 'user-loaded') {
            return this.userStore.payload!.language;
        }

        return 'en';
    }

    translate(key: string, language: Language = this.language, parameters: LabelParameters = {}): string {
        const label = this.labelsByKey.get(key);

        if (label === undefined) {
            return key;
        }

        let translatedText = label[language];

        for (const parameterKey of Object.keys(parameters)) {
            translatedText = translatedText.replace(`{${parameterKey}}`, parameters[parameterKey]);
        }

        return translatedText;
    }
}

export type Language = 'et' | 'en' | 'fi' | 'lt' | 'lv' | 'ru' | 'sv' | 'pl' | 'vi' | 'ja';

interface Label {
    en: string;
    et: string;
    fi: string;
    lt: string;
    lv: string;
    ru: string;
    sv: string;
    pl: string;
    vi: string;
    ja: string;
}

export interface LabelParameters {
    [key: string]: string;
}
